export const environment = {
  production: true,
    backendUrl: 'https://api.tecneplas.com/v1/',
    backendUrlPath: 'https://api.tecneplas.com/',
    // backendUrl: 'https://dev-api.tecneplas.com/v1/',
    // backendUrlPath: 'https://dev-api.tecneplas.com/',
    appVersion: require('../../package.json').version,
    // backendUrl: '',
    // backendUrlPath: 'http://localhost:3000/',
    FONTSIZE: {
        1: 7,
        2: 14,
        3: 28,
        4: 56
    }
};
